export default class SecurityManagerService {
  /* @ngInject */
  constructor(User, $rootScope, $q, $http, $cookies, $window, SmartVault) {
    this.User = User;
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$http = $http;
    this.$cookies = $cookies;
    this.$window = $window;
    this.SmartVault = SmartVault;

    this.GoogleAuth = null;
  }

  authenticate(email, password, skipTwoFactor) {
    return this.$http
      .post(`${process.env.SERVER_URL}/api/auth`, {
        email,
        password,
        skipTwoFactor,
      })
      .then((response) =>
        skipTwoFactor ? new this.User(response.data) : null
      );
  }

  authenticateTwoFactor(email, password, twoFactorCode) {
    return this.$http
      .post(`${process.env.SERVER_URL}/api/auth/two-factor`, {
        email,
        password,
        twoFactorCode,
      })
      .then((response) => new this.User(response.data));
  }

  authenticateByGoogle(accessToken) {
    return this.$http
      .post(`${process.env.SERVER_URL}/api/auth/google`, { accessToken })
      .then((response) => new this.User(response.data));
  }

  isAuthenticated() {
    const accessToken = this.getAccessToken();
    return (
      accessToken &&
      accessToken.token &&
      new Date(accessToken.expirationDate) > new Date()
    );
  }

  storeCredentials(accessToken, rememberMe) {
    this.$cookies.putObject("quoters_access_token", accessToken, {
      expires: rememberMe ? accessToken.expirationDate : undefined,
      secure: process.env.ENV === "prod" || process.env.ENV === "staging",
    });
  }

  removeCredentials() {
    this.$cookies.remove("quoters_access_token");
  }

  getAccessToken() {
    return this.$cookies.getObject("quoters_access_token");
  }

  loadUser() {
    return this.User.get().then((user) => {
      this.$rootScope.user = user;
      return user;
    });
  }

  getUser() {
    return this.$rootScope.user instanceof this.User
      ? this.$q.resolve(this.$rootScope.user)
      : this.loadUser();
  }

  async refreshUser() {
    await this.SmartVault.syncOrganizations();

    return this.loadUser().then((user) => {
      const slug = this.$rootScope.organization
        ? this.$rootScope.organization.slug
        : this.$rootScope.user.defaultOrganization.slug;
      this.$rootScope.organization = this.$rootScope.user.getOrganization(slug);
      this.$rootScope.$broadcast("refreshUser");
      this.$rootScope.$broadcast("refreshOrganization");

      return user;
    });
  }

  signUp(name, surname, email, password, newsletter, discounts, locale) {
    return this.User.create(
      name,
      surname,
      email,
      password,
      newsletter,
      discounts,
      locale
    );
  }

  resetPassword(email) {
    return this.User.resetPassword(email).then();
  }

  async signout(callback) {
    if (this.getAccessToken()) {
      await this.User.signOut();
    }

    this.removeCredentials();
    this.$rootScope.user = null;
    this.$rootScope.organization = null;
    if (callback && typeof callback === "function") callback();
  }
}
